import React from "react";
import * as SurveyReact from "survey-react-ui";
import { Serializer } from "survey-core";
import { ReactQuestionFactory } from "survey-react-ui";
import ChoicePillList, { type ChoicePillLayout } from "./ChoicePillList";

/**
 * Registers choice `tooltip` JSON property and pill renderers for
 * default radiogroup + checkbox questions sitewide.
 */
if (!Serializer.findProperty("itemvalue", "tooltip")) {
  Serializer.addProperty("itemvalue", {
    name: "tooltip",
    type: "string",
    category: "general"
  });
}

const registerChoicePillLayoutProperty = (questionType: string): void => {
  if (Serializer.findProperty(questionType, "choicePillLayout")) {
    return;
  }

  Serializer.addProperty(questionType, {
    name: "choicePillLayout",
    default: "stack",
    choices: ["stack", "wrap"],
    category: "layout"
  });
};

registerChoicePillLayoutProperty("checkbox");
registerChoicePillLayoutProperty("radiogroup");

type QuestionWithChoicePillLayout = {
  choicePillLayout?: ChoicePillLayout;
};

const getChoicePillLayout = (question: unknown): ChoicePillLayout => {
  const layout = (question as QuestionWithChoicePillLayout).choicePillLayout;
  return layout === "wrap" ? "wrap" : "stack";
};

class GlRadiogroupPills extends SurveyReact.SurveyQuestionRadiogroup {
  renderElement() {
    return (
      <ChoicePillList
        question={this.question}
        layout={getChoicePillLayout(this.question)}
        multi={false}
      />
    );
  }
}

class GlCheckboxPills extends SurveyReact.SurveyQuestionCheckbox {
  renderElement() {
    return (
      <ChoicePillList
        question={this.question}
        layout={getChoicePillLayout(this.question)}
        multi={true}
      />
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion("radiogroup", (props) =>
  React.createElement(GlRadiogroupPills, props)
);

ReactQuestionFactory.Instance.registerQuestion("checkbox", (props) =>
  React.createElement(GlCheckboxPills, props)
);

export {};
